import { createSelector } from 'reselect';

const selectCropSources = createSelector(
  (state) => (state.cropWidget && state.cropWidget.cropSources ? state.cropWidget.cropSources : {}),
  (cropSources) => cropSources
);

const selectCrop = createSelector(
  (state) => state.cropWidget.crop,
  (crop) => crop
);

const selectDefaultCrop = createSelector(
  (state) => state.cropWidget.defaultCrop,
  (defaultCrop) => defaultCrop
);

const selectShowSkipCropButton = (state) => state.widgetConfig.showSkipCropButton;

const selectCropOptions = createSelector(
  (state) => state.widgetConfig.croppingShowBackButton,
  (state) => state.widgetConfig.croppingAspectRatio,
  (state) => state.widgetConfig.croppingShowDimensions,
  (state) => state.widgetConfig.croppingCoordinatesMode,
  (state) => state.widgetConfig.croppingDefaultSelectionRatio,
  (state) => state.widgetConfig.minImageWidth,
  (state) => state.widgetConfig.minImageHeight,
  (state) => state.widgetConfig.maxImageWidth,
  (state) => state.widgetConfig.maxImageHeight,
  (state) => state.widgetConfig.cropping,
  (
    croppingShowBackButton,
    croppingAspectRatio,
    croppingShowDimensions,
    croppingCoordinatesMode,
    cropDefaultSelectSize,
    minImageWidth,
    minImageHeight,
    maxImageWidth,
    maxImageHeight,
    cropping
  ) => ({
    croppingShowBackButton,
    croppingAspectRatio,
    croppingShowDimensions,
    croppingCoordinatesMode,
    cropDefaultSelectSize,
    minImageWidth,
    minImageHeight,
    maxImageWidth,
    maxImageHeight,
    cropping,
  })
);

export { selectCropSources, selectCrop, selectDefaultCrop, selectCropOptions, selectShowSkipCropButton };
